<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>审核信息</i></p>
          <div class="totals-box plr24">
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">补贴类型</div>
              <div class="itemNum">{{ form.subsidyTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">月份</div>
              <div class="itemNum">{{ formatMonth(form.dataMonth)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实际发放月份</div>
              <div class="itemNum">{{ formatMonth(form.grantMonth)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">店员姓名</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            
            <template v-if="form.subsidyType == 'socialReimburse'">
              <div class="flex-row mb30">
                <div class="itemName">申请门店</div>
                <div class="itemNum">{{ form.applyShopName }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">报销门店</div>
                <div class="itemNum">{{ form.shopName }}</div>
              </div>
            </template>

            <div class="flex-row mb30">
              <div class="itemName">申请金额(元)</div>
              <div class="itemNum">{{ form.applyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核金额(元)</div>
              <div class="itemNum">{{ form.auditAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">审核备注</div>
              <div class="itemNum">{{ form.auditRemark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">创建人</div>
              <div class="itemNum">{{ form.addRecordType=='sys'?'系统':form.oxCname }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">创建时间</div>
              <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.subsidyType == 'openCleanSubsidy'">
              <div class="itemName">打扫时间</div>
              <div class="itemNum">{{ formatDay(form.beginDate) }} ～ {{ formatDay(form.endDate) }}</div>
            </div>

            <div v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager' || form.subsidyType == 'fare' || form.subsidyType == 'chef' || form.subsidyType == 'coverall' || form.subsidyType == 'bedding'">
              <div class="flex-row mb30" v-if="form.subsidyType == 'bedding'">
                <div class="itemName">类型</div>
                <div class="itemNum">{{form.beddingTypeCn}}</div>
              </div>
              <div class="flex-row mb30" v-if="form.subsidyType == 'coverall'">
                <div class="itemName">类型</div>
                <div class="itemNum">{{form.coverallTypeCn}}</div>
              </div>
              <div class="flex-row mb30" v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager'">
                <div class="itemName">开始时间</div>
                <div class="itemNum">{{ form.beginDate ? formatDay(form.beginDate) : '' }}</div>
              </div>
              <div class="flex-row mb30" v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager'">
                <div class="itemName">结束时间</div>
                <div class="itemNum">{{ form.endDate ? formatDay(form.endDate) : '' }}</div>
              </div>
              <div v-if="form.subsidyType == 'fare'">
                <div class="flex-row mb30">
                  <div class="itemName">交通工具</div>
                  <div class="itemNum">{{ form.vehicleCn }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">行程</div>
                  <div class="itemNum">{{ form.tripCn }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">起始站</div>
                  <div class="itemNum">{{ form.startStation }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName">终点站</div>
                  <div class="itemNum">{{ form.endStation }}</div>
                </div>
              </div>
            </div>

            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.uploadProofFlag=='enable'">
              <div class="itemName">凭证</div>
              <div class="itemNum itemNum-img">
                <div v-for="item in form.proofUrlList" :key="item" class="itemNumImgs">
                  <el-image
                    :src="item"
                    :preview-src-list="previewList"
                    @click="handPreview(item)"
                  ></el-image>
                </div>
              </div>
            </div>
            
            
            <div class="mb30" v-if="form.subsidyType == 'cashier' || form.subsidyType == 'viceShopManager'">
              <div class="itemName mb10">补贴明细</div>
              <!-- subsidyInfoItemList -->
              <el-table :data="form.subsidyInfoItemListBO.detailList" show-summary :summary-method="getSummaries" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="subsidyDate" width="auto" label="日期">
                  <template slot-scope="scope">
                    <span>{{formatDay(scope.row.subsidyDate)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="attendanceFlagCn" width="auto" label="是否出勤（含公休）" align="center"></el-table-column>
                <el-table-column prop="staffNumber" width="auto" label="在店人数" align="center"></el-table-column>
                <el-table-column prop="applyAmount" width="auto" label="补贴金额" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
          <p class="order-title-boxs" v-if="form.flowAuditRecordMapList.length > 0"><span class="blueBlock"></span><i>审核流程</i></p>
          <div class="totals-box plr24">
            <div v-for="(item,index) in form.flowAuditRecordMapList" :key="index" class="mb30" style="border-bottom: 1px solid #dceaed;">
              <div class="flex-row mb30">
                <div class="itemName">{{item.flowNodeName}}</div>
                <div class="itemNum">{{ item.auditOpName }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核人</div>
                <div class="itemNum">{{ item.auditOpName }} <span v-if="item.auditStatusDesc">（{{item.auditStatusDesc}}）</span></div>
              </div>
              <!-- <div class="flex-row mb30">
                <div class="itemName">审核金额</div>
                <div class="itemNum">{{ item.auditAmount }}</div>
              </div> -->
              <div class="flex-row mb30">
                <div class="itemName">审核时间</div>
                <!-- <div class="itemNum">{{ item.auditTime ? formatDate(item.auditTime) : '' }}</div> -->
                <div class="itemNum">{{ item.auditTimeFormart }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核备注</div>
                <div class="itemNum">{{ item.auditRemark }}</div>
              </div>
            </div>
          </div>
          <div class="drawer-footer pr24 pb10" v-if="form.auditFlag || form.cancelFlag">
            <el-button v-if="form.auditFlag" type="danger" @click="submitAudit('refuse')">拒绝</el-button>
            <el-button v-if="form.auditFlag" type="primary" @click="submitAudit('pass')">同意</el-button>
            <el-button v-if="form.cancelFlag" type="danger" @click="cancelClick">撤销</el-button>
          </div>
        </div>
      </div>
    </drawer>

  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "补贴详情",
      dialogHide: false,
      form: {
        flowAuditRecordMapList: [],
        subsidyInfoItemListBO: {}
      },
      previewList: [],
      moneys: ''
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data())
        this.$api.get(this.$url.subsidyApply.get, {
          id: org,
        }).then(res => {
          if (res) {
            console.log(res);
            this.addEditShow = true;
            if (Object.keys(res.subsidyInfoItemListBO).length && res.subsidyInfoItemListBO.detailList) {
              res.subsidyInfoItemListBO.detailList.map(item => {
                item.staffNumber = String(item.staffNumber);
              })
            }
            this.form = res;
            if (res.flowAuditRecordMapList) {
              this.form.flowAuditRecordMapList = res.flowAuditRecordMapList;
            } else {
              this.form.flowAuditRecordMapList = [];
            }
            console.log(this.form);
          }
        }).catch(error => {});
      });
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    submitAudit (type) {
      if (type == "pass" && (this.form.subsidyType == "fare" || this.form.subsidyType == "healthCheck" || this.form.subsidyType == "coverall" || this.form.subsidyType == "bedding")) {
        this.moneys = JSON.parse(JSON.stringify(this.form.auditAmount)) || '';
        this.$prompt('', '审核金额', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: "请输入",
          inputValue: this.moneys,
          inputPattern: /^(\d{0,8})(\.(\d{0,2}))?$/,
          inputErrorMessage: '请输入正确的金额，两位小数',
          closeOnClickModal: false,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm' && !instance.inputValue) {
              return this.$message.error('请输入审核金额');
            } else {
              done();
            }
          }
        }).then(({ value }) => {
          this.moneys = value;
          this.audit(type);
        }).catch(() => {});
      } else {
        this.moneys = JSON.parse(JSON.stringify(this.form.auditAmount)) || '';
        this.audit(type);
      }
    },
    audit (type) {
      this.$api.post(this.$url.subsidyApply.audit, {
        id: this.form.id,
        auditStatus: type,
        auditAmount: this.moneys
      }).then(res => {
        if (res) {
          this.$message.success("审批成功");
          this.addEditShow = false;
          this.$emit("change")
        }
      });
    },
    cancelClick () {
      this.$confirm('确定要撤销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        this.$api.get(this.$url.subsidyApply.cancel, {
          id: this.form.id
        })
        .then(res => {
          if (res) {
            this.$message.success("撤销成功");
            this.addEditShow = false;
            this.$emit("change")
          }
        });
      }).catch(() => {});
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index == columns.length - 1) {
          const values = data.map(item => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      if (sums[3]) sums[3] = sums[3].toFixed(2);
      return sums;
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.itemNum-img {
  display: flex;
  .itemNumImgs {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    .el-image {
      width: 100%;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  img {
    width: 100%;
    height: 100%; 
  }
}
.foot-msg {
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin: 20px 24px 10px;
  color: #999;
  p {
    margin-bottom: 10px;
  }
  .infos {
    color: #111;
    margin-bottom: 10px;
  }
}
.padding-no {
  padding: 10px 20px 0;
}
</style>